import React, { useState, useEffect } from "react";
import { ImageModalSlide } from "@molecules";
import { m, AnimatePresence } from "framer-motion";
import { toggleBodyScroll } from "@utils";
import { useAppState } from "@state";

const ImageModalContainer = ({ modalImages, initial }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [currentPage, setCurrentPage] = useState(initial);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [visible, setVisible] = useState(true);
  const [, dispatch] = useAppState();

  useEffect(() => {
    toggleBodyScroll(!visible);

    if (!visible) {
      dispatch({ type: "closeModal" });
    }

    if (visible) {
      document.documentElement.classList.add("is-locked");
    } else {
      document.documentElement.classList.remove("is-locked");
    }
  }, [visible]);

  return (
    <AnimatePresence initial>
      {visible && (
        <m.div
          key={modalImages[currentPage].uid}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="relative min-h-screen"
        >
          <ImageModalSlide
            {...modalImages[currentPage]}
            pageState={[currentPage, setCurrentPage]}
            visibleState={[visible, setVisible]}
            length={modalImages?.length}
          />
        </m.div>
      )}
    </AnimatePresence>
  );
};

ImageModalContainer.defaultProps = {};

export default ImageModalContainer;
